$(document).on('turbolinks:load', function() {

  // $('.new-account').on('click', 'input[type="radio"]', function(e) {
  //   $(this).closest('.radio-choice').addClass('selected');
  // });

  function closed_campaign() {
    $('#student_org').parent().next().find('ul').find('li').each(function() {
      $(this).on('click', function() {
        let value = $(this).attr("data-token");
        if (value == "0"){
          $('#closed_campaign').addClass('visible');
        }
      });
    });
  }

  $('.closed_campaign').on('click', function() {
    $('#student_org').val("");
    $('#student_org').next().text("");
  });

  function enable_li (subs_drop_id) {
    $('#'+subs_drop_id).parent().next().find('ul').find('li').each(function() {
      $(this).on('click', function() {
        let identity = $(this).parent().parent().parent().find('input').attr("id");
        if (["student_state","student_city"].includes(identity)){
          let value = $(this).attr("data-value");
          let subs_drop = identity == "student_state" ? "student_city" : "student_org"
          $.ajax({
            url: '/student_form_lists',
            type: 'POST',
            data: {
                  'type': identity,
                  'value': value
                },
            success: function (result) {
              $('#'+subs_drop).val("");
              $('#'+subs_drop).next().text("");
              $('#'+subs_drop).parent().removeClass('disable-dropdown');
              $('#'+subs_drop).parent().next().find('ul').html(result.data);
              closed_campaign();
            }
          });
        }
      });
    });
  }

  if($('#student_state').length>0) {
    $('ul.mdc-list li').on('click', function() {
      let identity = $(this).parent().parent().parent().find('input').attr("id");
      if (["student_state","student_city"].includes(identity)){
        let value = $(this).attr("data-value");
        let subs_drop = identity == "student_state" ? "student_city" : "student_org"
        $.ajax({
          url: '/student_form_lists',
          type: 'POST',
          data: {
                'type': identity,
                'value': value
              },
          success: function (result) {
            $('#'+subs_drop).val("");
            $('#'+subs_drop).next().text("");
            $('#'+subs_drop).parent().removeClass('disable-dropdown');
            $('#student_org').val("");
            $('#student_org').next().text("");
            $('#student_org').parent().addClass('disable-dropdown');
            $('#'+subs_drop).parent().next().find('ul').html(result.data);
            enable_li(subs_drop)
          }
        });
      }
    });
  }

  var initial_new_account = false;
  $('.new-account').on('click', '.radio-choice.organization-type', function(e) {
    $('.radio-choice.organization-type').toggleClass('hidden');
    $(this).toggleClass('hidden');

    var radio = $(this).find('input[type=radio]');
    var toggleTarget = $(this).data('toggle');
    if (!initial_new_account) {
      if(!$(e.target).is('input')) {
        if (radio.prop('checked') == true) {
          radio.prop('checked', false);
        } else {
          radio.prop('checked', true);
        }
      } else {
        if (!$('.' + toggleTarget).hasClass('hidden')) {
          radio.prop('checked', false);
        }
      }
    }

    initial_new_account = false;

    const val = radio.val(),
      label = val == 'umbrella' ? 'Discrict' : 'Organization';
    $('#organization').val(val);
    $('#entity_name').closest('.mdc-text-field').find('.mdc-floating-label').html(label + ' Name');

    if(label == 'Organization') {
      $('.is-club-container').show().find('input').prop( "disabled", false );
      $('.sign-up-1').hide();
      $('.sign-up-2').show();
    } else {
      $('.is-club-container').hide();
      $('.sign-up-1').show();
      $('.sign-up-2').hide();
    }

    if (val != 'student') {
      if ($(document).find('#video-registration-page').hasClass('hidden')) {
        $(document).find('#video-registration-page').removeClass('hidden');
        $(document).find('#image-registration-page').addClass('hidden');
      } else {
        $(document).find('#video-registration-page').addClass('hidden');
        $(document).find('#image-registration-page').removeClass('hidden');
      }
    }

    if(val == 'single'){
      $('.span-back-label').removeClass('hidden');
      $(this).addClass('hidden');
    }

    $(this).toggleClass('selected');

    $('.' + toggleTarget).toggleClass('hidden');
  });

  $('.new-account').on('click', '.back-sign-up', function(e) {
    e.preventDefault();
    var toggleTarget = $(this).data('toggle');
    $('.radio-choice.organization-type').removeClass('hidden');
    $('.' + toggleTarget).addClass('hidden');
    $('.span-back-label').addClass('hidden');
    $('.is-club-container').hide();
    $(document).find('#video-registration-page').addClass('hidden');
    $(document).find('#image-registration-page').removeClass('hidden');
    $('.sign-up-1').show();
    $('.sign-up-2').hide();
  });

  $('.new-account').on('change', '.select-org-trigger', function(e) {
    var select_target = $(this)
    if(select_target.val() == 'TMF Sales Rep'){
      $('#rep_email').removeClass('hidden');
      $('#rep_email').prop('required',true);
    } else {
      $('#rep_email').addClass('hidden');
      $('#rep_email').prop('required',false);
    }
  });

  if($('.new-account .organization-type input[type=radio]:checked').length) {
    initial_new_account = true;
    $('.new-account .organization-type input[type=radio]:checked').closest('.radio-choice.organization-type').trigger('click');
  }

  $('.new-account').on('change', '.is-club-container input', function(e) {
    if($('.new-account .organization-type input[type=radio]:checked').val() == 'single') {
      if($(this).val() == '1') {
        $('#entity_name').closest('.mdc-text-field').find('.mdc-floating-label').html('Club or Group Name');
      } else {
        $('#entity_name').closest('.mdc-text-field').find('.mdc-floating-label').html('Organization Name');
      }
    }
  });
  //$('.new-account .is-club-container input[type=radio]:checked').trigger('change');


  $('.new-account').on('click', '.create-account-actions a', function(e) {
    e.preventDefault();
    let $form = $('.new-account form')
    if(typeof document.createElement('input').checkValidity == 'function' &&
        typeof document.createElement('input').reportValidity == 'function' &&
        (!$('#entity_name')[0].checkValidity() || !$('#user_terms')[0].checkValidity())) {
      if(!$('#entity_name')[0].checkValidity()) {
        $('#entity_name')[0].reportValidity();
      }
      else if(!$('#user_terms')[0].checkValidity()) {
        $('#user_terms')[0].reportValidity();
      }
    } else {
      $.ajax({
        url: '/set_new_account.js',
        type: 'POST',
        data: $form.serialize(),
        success: function (result) {
          eval(result);
        }
      });
    }
  });

  $('.new-account').on('click', '.create-account-actions', function(e) {
    if($('.new-account .organization-type input[type=radio]:checked').val() == 'student'){
      e.preventDefault();
      let $form = $('.new-account form')
      $form.submit();
    }
  });


  if($('.step-navigation').length) {
    var step_navigation_steps = parseInt($('.step-navigation').data('steps')),
      step_navigation_step = 0,
      step_navigation_width;
    $('.step-navigation').on('click', 'a', function(e) {
      step_navigation_width = $('.welcome-screen-bottom .step, .levels .level').outerWidth();
      e.preventDefault();
      if($(this).hasClass('disabled')) return;
      if($(this).hasClass('back')) {
        step_navigation_step--;
        if(step_navigation_step < 0) step_navigation_step = 0;
      } else {
        step_navigation_step++;
        if(step_navigation_step > step_navigation_steps) step_navigation_step = step_navigation_steps;
      }
      $('.steps, .levels').css('left', step_navigation_step * step_navigation_width * -1);
      if(step_navigation_step == 0) {
        $('.step-navigation a.back').addClass('disabled');
      } else {
        $('.step-navigation a.back').removeClass('disabled');
      }
      if(($(window).width() <= 1024 && (step_navigation_step == (step_navigation_steps - 1))) || ($(window).width() > 1024 && (step_navigation_step == (step_navigation_steps - 3)))) {
        $('.step-navigation a.next').addClass('disabled');
      } else {
        $('.step-navigation a.next').removeClass('disabled');
      }
      if($('.step-navigation').hasClass('student-step-navigation')) {
        //setTimeout(function() {
          const margin_top = ($('.step:nth-of-type(' + (step_navigation_step + 1) + ')').outerHeight() + 60) + 'px';
          $('.step-navigation').css('margin-top', margin_top);
        //}, 200);
      }
    });
  }

  // $('.school-mission').on('click', '.welcome-screen .button', function(e) {
  //   e.preventDefault();
  //   $('.welcome-screen').hide();
  //   $('.goal-form, .mission-form').show();
  //   $('.onboarding-container').addClass('goal-form-container');
  // });

  $('.district-goal').on('click', '.goal-form .back-link', function(e) {
    e.preventDefault();
    $('.goal-form').hide();
    $('.welcome-screen').show();
    $('.onboarding-container').removeClass('goal-form-container');
  });

  $('.district-goal').on('click', '.goal-form .field a', function(e) {
    e.preventDefault();
    let $input = $('.goal-form input[type="number"]'),
      percent = parseInt($input.val());
    percent = $(this).hasClass('minus') ? percent - 5 : percent + 5;
    if(percent > 100) {
      percent = 100;
    }
    if(percent < 0) {
      percent = 0;
    }
    $input.val(percent);
    $('.goal-ring-container .pie_progress').asPieProgress('go', percent);
  });

  $('.inner-container').on('click', '.radio-choice.payment-distribution-type', function(e) {
    var radio = $(this).find('input[type=radio]');
    var distribution_container = $(document).find('.payment_distribution-opt3');
    var radio_id = radio.attr('id');

    if(!$(e.target).is('input')) {
      if (radio.prop('checked') == false) {
        radio.prop('checked', true);
      }
    }

    if(radio_id == 'campaign_payment_distribution_1') {
      if(!distribution_container.hasClass('hidden')){
        distribution_container.toggleClass('hidden');
      }
      distribution_container.find('#district').val(100);
      distribution_container.find('#schools').val(0);
      distribution_container.find('#district').attr('value',100);
      distribution_container.find('#schools').attr('value',0);
    }
    else if(radio_id == 'campaign_payment_distribution_2') {
      if(!distribution_container.hasClass('hidden')){
        distribution_container.toggleClass('hidden');
      }
      distribution_container.find('#district').val(0);
      distribution_container.find('#schools').val(100);
      distribution_container.find('#district').attr('value',0);
      distribution_container.find('#schools').attr('value',100);
    }
    else if(radio_id == 'campaign_payment_distribution_3') {
      if(distribution_container.hasClass('hidden')){
        distribution_container.toggleClass('hidden');
      }
      distribution_container.find('#district').val(null);
      distribution_container.find('#schools').val(null);
      distribution_container.find('#district').attr('value',null);
      distribution_container.find('#schools').attr('value',null);
    }
  });

  $('.district-goal, .school-goal').on('input', 'input[type="number"]', function(e) {
    $('.district-goal input[type="range"], .school-goal input[type="range"]').val($(this).val());
  });

  $('.district-goal, .school-goal').on('change', 'input[type="range"]', function(e) {
    $('.district-goal input[type="number"], .school-goal input[type="number"]').val($(this).val());
  });

  // $('.district-campaign-dates').on('change', '#campaign_start_date', function(e) {
  //   let end_date = new Date($(this).val());
  //   end_date.setDate(end_date.getDate() + 11);
  //   $('#campaign_end_date').val(getDateString(end_date));
  // });

  // $('.district-campaign-dates').on('change', '#campaign_end_date', function(e) {
  //   let start_date = new Date($(this).val());
  //   start_date.setDate(start_date.getDate() - 9);
  //   $('#campaign_start_date').val(getDateString(start_date));
  // });

  $('.new-student-account').on('submit', 'form', function(e) {
    if ($('.role-select input').val() === 'true') {
      return true;
    }
    let el = $(document).find('.grade-select .mdc-select .mdc-select--hidden-input');
    let grade = el.val();
    if(el[0] && grade.length <= 0) {
      e.preventDefault();
      $('.grade-span').show();
      enableStudentForm();
    }

    $('.birthday-invalid-message, .birthday-error-message').hide();

    if ($('.date-entry-fields input.year').val().length != 4) {
      e.preventDefault();
      $('.birthday-invalid-message span').text('Enter a valid birthday year to continue.')
      $('.birthday-invalid-message').show();
      enableStudentForm();
    }
    else {
      let year = parseInt($('.date-entry-fields input.year').val()),
        month = parseInt($('.date-entry-fields input.month').val()) - 1,
        day = parseInt($('.date-entry-fields input.day').val()),
        birthday = new Date(year, month, day);
      if (day > new Date(year, (month + 1), 0).getDate()) {
        e.preventDefault();
        $('.birthday-invalid-message span').text('Enter a valid birthday day to continue.')
        $('.birthday-invalid-message').show();
        enableStudentForm();
      }
      else if(!birthday.isValid()) {
        e.preventDefault();
        $('.birthday-invalid-message span').text('Enter a valid birthday to continue.')
        $('.birthday-invalid-message').show();
        enableStudentForm();
      } else {
        let seconds = Math.floor((new Date() - birthday) / 1000),
          years = seconds / 31536000;

        if(years < 13) {
          $('.modal-overlay').addClass('visible');
          e.preventDefault();
        }
      }
    }

  });

  $('.modal-overlay').on('click', '.modal.parent-check-modal .close', function(e) {
    e.preventDefault();
    $('form input[type="submit"]').prop( "disabled", false );
  });

  $('.district-administrators, .school-administrators').on('click', '#add_admin_modal_button, #add_admin_modal_link, #add_admin_modal .close', function(e) {
    e.preventDefault();
    $('#add_admin_modal').toggleClass('visible');
  });

  $(document).on('click', '#add_admin_submit', function(e) {
    e.preventDefault();
    $(this).closest('form').find('input[type="submit"]').trigger('click');
  });

  $(document).on('submit', 'form.add-admministrator', function(e) {
    e.preventDefault();

    var first_name = $(this).find('input[name="first_name"]').val(),
      last_name = $(this).find('input[name="last_name"]').val(),
      school = $(this).find('input[name="school_name"]').val(),
      email = $(this).find('input[name="email"]').val();
    addDistrictAdministrator(first_name, last_name, school, email);

    $(this).find('input[type="text"], input[type="email"]').val('');
    $('#add_admin_modal').removeClass('visible');
  });

  $('#administrator-csv-upload-form input[type="file"]').on('change', function() {
    $('#administrator-csv-upload-form input[type="submit"]').trigger('click');
    $(this).val('');
  });

  $('#students-csv-upload-form input[type="file"]').on('change', function() {
    $('#students-csv-upload-form input[type="submit"]').trigger('click');
    $(this).val('');
  });

  $('.district-administrators, .school-administrators, .school-student-onboarding .invite-form').on('click', '.added-admin .remove a', function(e) {
    e.preventDefault();
    $(this).closest('.added-admin').remove();
    if(!$('.admin-holder .added-admin').length) {
      $('.admins-added-holder').hide();
      $('.add-actions').show();
      $('#invite-admins-trigger, #preview-email-trigger').addClass('disabled');
    }
  });

  $('#invite-admins-trigger').on('click', function(e) {
    e.preventDefault();
    if($(this).hasClass('disabled')) return;
    if(!$('.admin-holder .added-admin').length) {
      alert('Please add at least one admin to invite.');
    }
    else {
      $('.admin-holder').submit();
    }
  });

  $('.school-onboarding-mission').on('click', '.welcome-screen .button', function(e) {
    e.preventDefault();
    $('.welcome-screen').hide();
    $('.mission-form').show();
  });

  $('.school-onboarding-mission').on('click', '.mission-form .back-link', function(e) {
    e.preventDefault();
    $('.mission-form').hide();
    $('.welcome-screen').show();
  });

  $('.school-logo').on('change', '#school-logo-upload-form input[type="file"]', function() {
    $(this).closest('form').find('input[type="submit"]').trigger('click');
  });

  $('.school-logo').on('click', '.delete-image', function(e) {
    e.preventDefault();
    var $form = $(this).closest('form');
    $form.find('#delete_image').val('true');
    $form.find('input[type="submit"]').trigger('click');
  });

  $('.school-student-onboarding').on('click', '#show-register-link', function(e) {
    e.preventDefault();
    $('.student-invitation-link-holder').show();
    $('.school-student-onboarding').addClass('link-shown');
  });

  $('.school-student-onboarding').on('click', '.skip-continue .button.show-invite-form, .back-to-invites', function(e) {
    e.preventDefault();
    $('.school-student-onboarding').removeClass('link-shown').removeClass('trix-form');
    $('.skip-continue, .email-preview').hide();
    $('.invite-form').show();
  });

  $('.school-student-onboarding').on('click', '.invite-form .cancel-link', function(e) {
    e.preventDefault();
    $('.school-student-onboarding').removeClass('trix-form');
    $('.invite-form, .email-preview').hide();
    $('.skip-continue').show();
  });

  $('.school-student-onboarding').on('click', '.add-later', function(e) {
    e.preventDefault();
    $('.invite-form').hide();
    $('.school-student-onboarding').addClass('trix-form');
    $('.email-preview').show();
    $('.email-preview input[type="submit"]').val('Save Email');

  });

  $('.school-student-onboarding').on('click', '#preview-email-trigger', function(e) {
    e.preventDefault();
    if($(this).hasClass('disabled')) return;
    if(!$('.admin-holder .added-admin').length) {
      alert('Please add at least one admin to invite.');
    }
    else {
      $('.invite-form').hide();
      $('.school-student-onboarding').addClass('trix-form');
      $('.email-preview').show();
      $('.email-preview input[type="submit"]').val('Send Invites');
    }
  });

  $('.school-student-onboarding').on('submit', '.email-preview form', function(e) {
    e.preventDefault();
    $('#email-text-copy').val(document.querySelector("trix-editor").value);
    $('.admin-holder').submit();
  });

  $('.school-onboarding-download-invites').on('click', '.download-screen .button', function(e) {
    e.preventDefault();
    $('.download-screen').hide();
    $('.downloaded-screen').show();
  });

  $('.student-onboarding').on('click', '.information-form .button', function(e) {
    e.preventDefault();
    $('#guidelines_aggree').prop('disabled', true);
    if(!$(this).closest('form')[0].checkValidity()) {
      $(this).closest('form').find('input[type="submit"]').click();
    }
    else {
      $('.information-form').hide();
      $('.review-information').show();
    }
    $('#guidelines_aggree').prop('disabled', true);
  });

  $('.student-onboarding').on('click', '.information-form .button', function(e) {
    e.preventDefault();
    $('#student_terms').prop('disabled', true);
    if(!$(this).closest('form')[0].checkValidity()) {
      $(this).closest('form').find('input[type="submit"]').click();
    }
    else {
      $('.first-name-value').text($('#student_user_attributes_first_name').val());
      $('.last-name-value').text($('#student_user_attributes_last_name').val());
      $('.school-value').text($('#student_school').val());
      $('.grade-value').text($('#student_grade option:selected').text());
      $('.information-form').hide();
      $('.review-information').show();
    }
    $('#student_terms').prop('disabled', false);
  });

  $('.school-logo').on('change paste keyup', 'input[type="text"]', function(e) {
    if(!$(this).val()) {
      $(this).val('#');
    }
    else if($(this).val().length == 1 && $(this).val() != '#') {
      $(this).val('#');
    }
    if(/^#+([a-fA-F0-9]{6}|[a-fA-F0-9]{3})$/i.test($(this).val())) {
      $(this).prev('.color-preview').css('background', $(this).val());
      $(this).removeClass('invalid');
    } else {
      $(this).prev('.color-preview').css('background', 'transparent');
      $(this).addClass('invalid');
    }
  });

  $('.school-logo input[type="text"]').trigger('change');

  $('.school-logo').on('submit', '#school-colors-form', function() {
    $('.school-logo input[type="text"].invalid').val('');
  });

  $('.student-onboarding').on('click', '.review-information .button', function(e) {
    e.preventDefault();
    $('.review-information').hide();
    if($(this).hasClass('next')) {
      $('.welcome-screen').show();
    }
    else {
      $('.information-form').show();
    }
  });

  $('.student-onboarding').on('click', '.welcome-screen .button', function(e) {
    e.preventDefault();
    $('.welcome-screen').hide();
    $('.community-guidelines').show();
  });

  if($('.district-goal .goal-ring-container').length) {
    if(!$('.goal-ring-container .pie_progress svg').length) {
      $('.goal-ring-container .pie_progress').asPieProgress({
        namespace: 'pie_progress',
        min: 0,
        max: 100,
        size: 216,
        barcolor: '#2DABBC',
        barsize: 48,
        trackcolor: '#EAECEE',
        numberCallback: function(n) {
          var percentage = this.getPercentage(n);
          $('.pie_progress__number').text(percentage + '%');
        }
      });
      $('.goal-ring-container .pie_progress').asPieProgress('finish');
    }
  }

  // Enable / Disable admin onboarding submits

  $('.admin-onboarding').on('change paste keyup', '.mission-form #school_mission', function() {
    $(this).closest('form').find('input[type="submit"]').prop('disabled', $(this).val() == '');
  });
  $('.mission-form #school_mission').trigger('change');

  $('.admin-onboarding').on('change paste keyup', '#campaign_start_date', function() {
    $(this).closest('form').find('input[type="submit"]').prop('disabled', $(this).val() == '');
  });


  $('.admin-onboarding #campaign_start_date').trigger('change');

  $('.admin-onboarding').on('click', '#paper-check-form-trigger, #paper-check-form-cancel', function(e) {
    e.preventDefault();
    $('.payment-choice, .paper-check-form').toggle();
  });

  $('.admin-onboarding-new').on('click', '#paper-check-form-trigger, #paper-check-form-cancel', function(e) {
    e.preventDefault();
    $('.payment-choice, .paper-check-form').toggle();
  });

  $('.admin-onboarding, .payment-information').on('click', '.payment-choice-trigger', function(e) {
    e.preventDefault();
    let choice;
    if ($(this).attr('id') == 'check-payment-button') {
      choice = 'check';
    } else {
      choice = ($(this).attr('id') == 'stripe-payment-button') ? 'stripe' : 'null';
    }
    $('#payment-choice-input').val(choice);
    $('#payment-choice-form').submit();
  });

  if ($(".slidecontainer input#pitch_goal_amount").length>0){
    var slider = document.getElementById("pitch_goal_amount");
    var output = document.getElementById("demo");
    output.innerHTML = slider.value;

    slider.oninput = function() {
      output.innerHTML = this.value;
    }
  }

  if($('.role-select').length>0) {
    $('.role-select ul.mdc-list li').on('click', function() {
      if ($(this).text() == 'Parent') {
        $('.field.date-entry').addClass('hidden');
        $('#birthday_month').prop('required', false);
        $('#birthday_day').prop('required', false);
        $('#birthday_year').prop('required', false);
        $('.grade-select').addClass('hidden');
      } else {
        $('.field.date-entry').removeClass('hidden');
        $('#birthday_month').prop('required', true);
        $('#birthday_day').prop('required', true);
        $('#birthday_year').prop('required', true);
        $('.grade-select').removeClass('hidden');
      }
    });
  }

  let rewardsCenterOnboardingModal = $("#rewards-center-onboarding-modal")
  $("#sign-us-up-button").on("click", function () {
    rewardsCenterOnboardingModal.show()
  })
  $("#rewards-center-onboarding-modal-close").on("click", function () {
    rewardsCenterOnboardingModal.hide()
  })
  $(window).on('click', function (event) {
    if (event.target === rewardsCenterOnboardingModal.get(0)) {
      rewardsCenterOnboardingModal.hide()
    }
  })

  let winVideoModal = $("#win_video_modal_sign_up")

  if (winVideoModal){
    winVideoModal.show()
    winVideoModal.css('display', 'block')
  }


  $(window).on('click', function (event) {
    if (event.target === winVideoModal.get(0)) {
      winVideoModal.hide()
    }
  })

});

function getDateString(date) {
  let dateString = (date.getFullYear() + '-'
    + ('0' + (date.getMonth() + 1)).slice(-2)
    + '-' + ('0' + (date.getDate())).slice(-2));
  return dateString;
}

function addDistrictAdministrator(first_name, last_name, school, email) {
  if(!first_name) return;
  if($('.admin-holder').hasClass('empty')) {
    $('.admin-holder').removeClass('empty');
    $('.admin-holder p.empty-text').remove();
  }
  var $admin = $('<div class="added-admin"></div>'),
    $info = $('<div class="admin-info"></div>');
  $info.append('<p class="admin-name">' + first_name + ' ' + last_name + '</p>');
  $info.append('<input type="hidden" name="admin[][first_name]" value="' + first_name +'">');
  $info.append('<input type="hidden" name="admin[][last_name]" value="' + last_name +'">');
  if(school) {
    $info.append('<p>' + school + '</p>');
    $info.append('<input type="hidden" name="admin[][school_name]" value="' + school +'">');
  }
  $info.append('<p>' + email + '</p>');
  $info.append('<input type="hidden" name="admin[][email]" value="' + email +'">');
  $admin.append($info);
  $admin.append('<div class="remove"><a href="#"></a></div>');
  $('.admin-holder').prepend($admin);
  $('.add-actions').hide();
  $('.admins-added-holder').show();
  $('#add_admin_modal').removeClass('visible');
  $('#invite-admins-trigger, #preview-email-trigger').removeClass('disabled');

}

Date.prototype.isValid = function () {
    // An invalid date object returns NaN for getTime() and NaN is the only
    // object not strictly equal to itself.
    return this.getTime() === this.getTime();
};

function enableStudentForm () {
  $('.new-student-account form input[type="submit"]').prop('disabled', false);
  setTimeout(function() {
    $('.new-student-account form input[type="submit"]').prop('disabled', false);
  }, 150);
}




